/* global alert */

import React, { useCallback, useContext, useState } from 'react';
import { Card } from 'react-bootstrap';
import { CustomerContext } from './context/CustomerContext';
import AccountEditAddressModal from './AccountEditAddressModal';
import { bool, number, oneOfType, string } from 'prop-types';

const AccountAddress = ({ id, firstName, lastName, company, address1, city, state, zip, country, isDefault }) => {
    const [show, setShow] = useState(false);
    const name = [
        firstName,
        lastName,
    ].filter(Boolean).join(' ');
    const cityStateZip = [
        city,
        state,
        zip,
    ].filter(Boolean).join(' ');
    const {
        customerData,
        fetchCustomerData,
    } = useContext(CustomerContext);
    const handleUpdate = () => {
        fetchCustomerData();
    };
    const handleDeleteAddress = useCallback(async () => {
        try {
            const response = await fetch(
                new URL(`/api/customer/${customerData.id}/mailingAddresses/${id}`,
                    process.env.APP_URL), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            const data = await response.json();
            if (data.error || !data.success) {
                return alert(data.error ?? 'Failed to remove address.');
            }
            handleUpdate();
        } catch (e) {
            console.error(e);
            alert(e);
        }
    }, [customerData.id, id]);
    return (<>
        <Card
            className={'account--address mt-4 mb-4'}
            style={{ width: '18rem' }}>
            <Card.Body>
                <Card.Title>{isDefault === true ? 'Default' : 'Mailing'} Address</Card.Title>
                <Card.Subtitle
                    className={'mb-2 text-muted'}>{company ?? name}</Card.Subtitle>
                {company && (<Card.Text>{name}</Card.Text>)}
                <Card.Text>{address1}</Card.Text>
                <Card.Text>{cityStateZip}</Card.Text>
                <Card.Text>{country}</Card.Text>
                <Card.Link
                    style={{ textDecoration: 'none',
                        cursor: 'pointer' }}
                    onClick={() => setShow(true)}>Edit</Card.Link>
                <Card.Link
                    style={{ textDecoration: 'none',
                        cursor: 'pointer' }}
                    onClick={handleDeleteAddress}>Delete</Card.Link>
            </Card.Body>
        </Card>
        <AccountEditAddressModal
            show={show}
            setShow={setShow}
            mailingAddress={customerData.MailingAddresses
                .filter((address) => address.id === parseInt(id))[0]}
            onUpdate={handleUpdate}
        />
    </>);
};

AccountAddress.propTypes = {
    id: oneOfType([number, string]),
    firstName: string,
    lastName: string,
    company: string,
    address1: string,
    city: string,
    state: string,
    zip: string,
    country: string,
    isDefault: bool,
};

export default AccountAddress;